/** 水费方案 /metering/fee/water-plan（waterPlan.vue） */
export default {
  waterPlanPage: {
    sectionTitle: '水费方案',
    btnAddPlan: '新增方案',
    emptyTable: '暂无水费方案数据',
    emptyNoPermission: '暂无查看权限',
    colPlanId: '方案ID',
    colPlanName: '方案名称',
    colPrice: '水价(元/吨)',
    colUpdated: '更新时间',
    colAction: '操作',
    btnAdjust: '调价',
    btnBatchBind: '批量绑定',
    modalTitleEdit: '调整水价',
    modalTitleAdd: '新增方案',
    formPlanName: '方案名称',
    phPlanName: '请输入方案名称',
    labelWaterPrice: '水价',
    unitPerTon: '元/吨',
    warnEditNote: '注：修改方案会同时更改相应水表计费金额',
    labelPhoneBound: '绑定手机',
    labelVerifyCode: '验证码',
    phVerifyCode: '请输入验证码',
    sendCode: '发送验证码',
    resendIn: '{n} 秒后可重发',
    btnCancel: '取消',
    btnConfirm: '确定',
    drawerTitle: '批量绑定水表',
    tabPrivate: '专用水表',
    tabShare: '公摊水表',
    tabFormula: '公式水表',
    phSearchMeter: '搜索水表名称',
    selectAll: '全选',
    tagShareGroup: '公摊组',
    tagBound: '已绑定',
    emptyTreeNoMatch: '没有找到匹配的水表',
    emptyTreeNoData: '暂无水表数据',
    selectedWaters: '已选择 {count} 个水表',
    btnConfirmBind: '确认绑定',
    msgLoadFail: '获取数据失败',
    msgNoOperate: '暂无操作权限',
    msgSmsSent: '验证码已发送',
    msgSmsFail: '发送验证码失败',
    msgNameRequired: '请输入方案名称',
    msgPriceRequired: '请填写水价',
    msgPriceZero: '水价不可为0',
    titleTip: '提示',
    btnOk: '确定',
    confirmModify: '确认修改方案？',
    confirmAdd: '确认新增方案？',
    msgOpOk: '操作成功',
    msgOpFail: '操作失败',
    confirmBindWaters: '确认绑定 {count} 个水表到该方案？',
    msgBindOk: '绑定成功',
    msgBindFail: '绑定失败',
    msgSelectWaters: '请选择要绑定的水表',
    msgSelectNewWaters: '请选择新的水表进行绑定',
    msgMeterListFail: '获取水表列表失败'
  }
}
